import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-logo">
            <img src="/adept_services_white.png" alt="Adept Services" className="logo-image" />
          </div>
          
          <div className="footer-nav">
            <div className="nav-column">
              <h4>About Us</h4>
              <ul>
                <li><Link to="/about">Our Team</Link></li>
                <li><Link to="/esg">Sustainability Approach</Link></li>
                <li><Link to="/esg">Community Engagement</Link></li>
                <li><Link to="/about">Leadership & Governance</Link></li>
              </ul>
            </div>
            
            <div className="nav-column">
              <h4>Solutions & Innovation Services</h4>
              <ul>
                <li><Link to="/#sectors">Industries We Service</Link></li>
                <li><Link to="/#services">Our Technology</Link></li>
              </ul>
            </div>
            
            <div className="nav-column">
              <h4>Connect With Us</h4>
              <ul>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/contact">Locations & Reach</Link></li>
              </ul>
            </div>
            
            <div className="nav-column">
              <h4>Careers at Adept</h4>
              <ul>
                <li><Link to="/careers">Worklife at Adept</Link></li>
                <li><Link to="/careers">Open Roles</Link></li>
                <li><Link to="/careers">Recruitment FAQs</Link></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-tagline">
            <div className="tagline-text">
              <div className="tagline-line1">Adept Solutions,</div>
              <div className="tagline-line2">Limitless Possibilities</div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <a href="https://www.linkedin.com/company/adept-services-pty-ltd/" target="_blank" rel="noopener noreferrer" className="linkedin-icon">
              <img src="/icons/LinkedIn_logo_initials.png" alt="LinkedIn" />
            </a>
            <div className="copyright-info">
              <span>© 2025 Adept Services Pty Ltd</span>
              <span>ABN 81 628 366 183</span>
              <span>| <Link to="/privacy">Privacy</Link> | <Link to="/sitemap">Site Map</Link></span>
            </div>
            <div className="rights-reserved">
              The content on this website is the property of Adept Services Pty Ltd. All rights reserved.
            </div>
          </div>
        </div>
        
        <div className="footer-graphic">
          <img src="/hero/a_adept.png" alt="Adept Services" className="background-a" />
        </div>
      </div>
    </footer>
  )
}

export default Footer
